import { inject } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { CompanyService } from 'src/app/company/company.service';
import { Premiumreportservice } from 'src/app/company/premiumreport/data-access/services/premiumreportservice';
import { IOperatorClass } from './OperatorClass';
import { OperatorInput, OperatorOutput } from './models/models';

const USER_DEFINED_COLUMNS_SHEET_INDEX = 5;

export class UserDefinedColumnOperator implements IOperatorClass {
    private readonly companyService = inject(CompanyService);
    private readonly premiumreportservice = inject(Premiumreportservice);

    private getCellValue(worksheet: any, row: number, col: number): any {
        const value = worksheet.rows(row).cells(col).value;
        return value !== undefined && value !== null ? String(value).trim() : '';
    }

    private readUserDefinedColumnsFromExcel(workbook: any): any[] {
        const worksheet = workbook.worksheets(USER_DEFINED_COLUMNS_SHEET_INDEX);
        const udColumnsFromExcel: any[] = [];
        let rowIndex = 1; // skip header row

        while (true) {
            const name1 = this.getCellValue(worksheet, rowIndex, 0);
            const name2 = this.getCellValue(worksheet, rowIndex, 1);
            const name3 = this.getCellValue(worksheet, rowIndex, 2);
            const name4 = this.getCellValue(worksheet, rowIndex, 3);
            const isoCol = this.getCellValue(worksheet, rowIndex, 4);
            const matchCol = this.getCellValue(worksheet, rowIndex, 5);      

            const columnName = [name1, name2, name3, name4]
                .filter(v => v !== '')
                .join(' ');
            
            if (!columnName) break; // stop if no more columns

            udColumnsFromExcel.push({
                Name1: name1,
                Name2: name2,
                Name3: name3,
                Name4: name4,
                columnName: columnName,
                ISOCol: isoCol=='YES'?'on':'off',
                MatchCol: matchCol,
            });

            rowIndex++;
        }

        return udColumnsFromExcel;
    }

    
    private getIsoLine(isoLineRaw: string): string {
        let isoLineNumber = '';
        if (isoLineRaw && isoLineRaw !== '0' && isoLineRaw.toLowerCase() !== 'select') {
            const match = isoLineRaw.match(/\d+/);
            const firstNum = match ? match[0] : null;
            isoLineNumber = firstNum ?? '';
        }
        return isoLineNumber;
    }

    async runOperator(operatorInput: OperatorInput): Promise<OperatorOutput> {
        const workbook = operatorInput.workbook;
        if (!workbook) {
            return { status: 'error', message: ['Workbook not found.'], operatorInput };
        }

        const udSheet = workbook.worksheets(USER_DEFINED_COLUMNS_SHEET_INDEX);
        if (!udSheet) {
            return { status: 'error', message: ['User Defined Columns sheet not found.'], operatorInput };
        }

        const udColumnsFromExcel = this.readUserDefinedColumnsFromExcel(workbook);
        if (udColumnsFromExcel.length === 0) {
            return { status: 'skipped', operatorInput };
        }
        debugger


        // Update udColumns with values read from the Excel file
        for (let i = 0; i < udColumnsFromExcel.length; i++) {
            debugger
            const udColumn = Object();
            udColumn.ColName1 = udColumnsFromExcel[i].Name1;
            udColumn.ColName2 = udColumnsFromExcel[i].Name2;
            udColumn.ColName3 = udColumnsFromExcel[i].Name3;
            udColumn.ColName4 = udColumnsFromExcel[i].Name4;
            udColumn.ISOCol = udColumnsFromExcel[i].ISOCol;
            udColumn.ColNo = `${i+4}`;
            udColumn.MatchCol = this.getIsoLine(udColumnsFromExcel[i].MatchCol.trim());
            udColumn.ColName = udColumnsFromExcel[i].columnName;
            var strheadinglength = udColumn.ColName1.trim().length + udColumn.ColName2.trim().length + udColumn.ColName3.trim().length + udColumn.ColName4.trim().length;

            udColumn.ColName = udColumn.ColName + " " + udColumn.ColName2 + " " + udColumn.ColName3 + " " + udColumn.ColName4;
            udColumn.ColName = udColumn.ColName.trim();
            if (udColumn.ColName.trim() == '') {
                return { status: 'error', message: ['At least one heading is required to add and save new columns.'], operatorInput };
            }
            if (strheadinglength > 70) {
                return { status: 'error', message: ['Total text length of Heading Line(s) must not be exceed 70 characters.'], operatorInput };
            }
            var save$ = this.companyService.saveUserDefinedCol(operatorInput.prfyear, operatorInput.prfGroup, operatorInput.prfnumber as string, udColumn);
            let saveResp: any;
            if (!save$) {
                return {
                    status: 'error',
                    message: ['Failed to save user defined premium details.'],
                    operatorInput,
                };
            }
            try {
                saveResp = await firstValueFrom(save$);
            } catch {
                return { status: 'error', message: ['Failed to save user defined premium details.'], operatorInput };
            }
        }








        return { status: 'success', operatorInput };
    }
}
